export default __webpack_public_path__ + "static/media/container-h.23ca4ac7.png";